import NewSite from "../../components/NewSite";

const NewSitePage: React.FC = () => {
  return <NewSite />;
};

export default NewSitePage;
